import {Helmet} from 'react-helmet';
import AboutUs from "../aboutus";
import Contact from "../contact";

const faqsContent = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": [
    {
      "@type": "Question",
      "name": "What is SEO?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "SEO stands for Search Engine Optimization. It involves optimizing your website and content to improve rankings on search engines like Google."
      }
    },
    {
      "@type": "Question",
      "name": "Why is SEO important for my business?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "SEO helps your business get discovered online, generate more traffic, and convert visitors into customers without relying only on paid ads."
      }
    },
    {
      "@type": "Question",
      "name": "What SEO services do you offer?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "I offer on-page SEO, off-page SEO, technical audits, keyword research, local SEO, competitor analysis, backlink building, and content optimization."
      }
    },
    {
      "@type": "Question",
      "name": "How long does it take to see SEO results?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "SEO is a long-term strategy. Most websites start seeing noticeable improvements within 2 to 3 months depending on competition and domain strength."
      }
    },
    {
      "@type": "Question",
      "name": "Do you work with local businesses in Gurgaon?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. I specialize in local SEO strategies for businesses in Gurgaon, Delhi NCR, and across India."
      }
    },
    {
      "@type": "Question",
      "name": "Can you help improve my Google My Business profile?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. I optimize your GMB profile with relevant keywords, categories, services, photos, and local citations to increase map visibility."
      }
    },
    {
      "@type": "Question",
      "name": "What tools do you use for SEO audits?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "I use tools like Google Search Console, Ahrefs, SEMrush, Screaming Frog, and GTmetrix to audit and improve website SEO."
      }
    },
    {
      "@type": "Question",
      "name": "Will you provide SEO reports?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. You will receive monthly performance reports with keyword rankings, traffic growth, technical fixes, and next steps."
      }
    },
    {
      "@type": "Question",
      "name": "Do you follow Google’s SEO guidelines?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. I follow 100% white-hat SEO practices that are compliant with Google’s Webmaster Guidelines and avoid penalties."
      }
    },
    {
      "@type": "Question",
      "name": "Do you guarantee #1 ranking on Google?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "No ethical SEO professional can guarantee #1 ranking, but I guarantee improvements in rankings, traffic, and visibility using proven strategies."
      }
    },
    {
      "@type": "Question",
      "name": "Can I combine SEO with Google Ads?",
      "acceptedAnswer": {
        "@type": "Answer",
        "text": "Yes. SEO and PPC together offer a powerful digital strategy — one builds long-term visibility while the other delivers immediate results."
      }
    }
  ]
}

function App1() {
  return (
   <>
   <Helmet>
    <script type="application/ld+json">
          {JSON.stringify(faqsContent)}
        </script>
<title>SEO Services in Gurgaon | Expert Search Engine Optimization by Pankaj</title>

<meta name="description" content="Improve your Google rankings and get more traffic with professional SEO services in Gurgaon. On-page, off-page & technical SEO by expert freelancer Pankaj." />

<meta name="keywords" content="seo services gurgaon, freelance seo expert, search engine optimization india, on-page seo, off-page seo, technical seo audit, google ranking specialist, seo consultant in gurgaon, local seo services, website seo expert" />

<meta property="og:title" content="SEO Services in Gurgaon | Expert Search Engine Optimization by Pankaj" />
<meta property="og:description" content="Professional SEO services to boost visibility, traffic, and conversions. On-page, off-page, and local SEO handled by experienced freelancer." />
<meta property="og:site_name" content="Pankaj | Freelance SEO Expert in Gurgaon" />
<meta property="og:url" content="https://www.pankj.com/seo-services" />
<meta property="og:image" content="https://www.pankj.com/assets/img/dpnew.jpg" />

<meta name="twitter:title" content="SEO Services in Gurgaon | Expert Search Engine Optimization by Pankaj" />
<meta name="twitter:description" content="Freelance SEO services for websites and businesses in India. Keyword research, optimization, backlinks & more by Pankaj." />
<meta name="twitter:image" content="https://www.pankj.com/assets/img/dpnew.jpg" />

<link rel="canonical" href="https://www.pankj.com/search-engine-optimization" />

</Helmet>
    <section id="hero" className="hero d-flex align-items-center fixedabove">
   <video
                className="mainsliderbg"
                autoPlay
                muted
                loop={true} style={{width:'100%'}}>
{/*                <source src="assets/img/bg.mp4" type="video/mp4" />*/}
                <source src="assets/img/pankaj-web-designer2.mp4" type="video/mp4" />
                <source src="bg.ogg" type="video/ogg" />
  </video>
<div className="mainsliderbg">
     <div className="container-fluid">
      <div className="row">
        <div className="col-lg-6 d-flex flex-column">
            <img src="../assets/img/thyear.webp" className="imgsz" alt="Website Designer" />

 <h1 className="multiple_effects fzsml" id="text3d">Search Engine Optimization (SEO)</h1>
          <div className="content_sec" data-aos="fade-up" data-aos-delay="400">Take a look at some of my works, and if you like them, feel free to contact me.</div>
  <div data-aos="fade-up" data-aos-delay="600">
            <div className="text-center text-lg-start">
              <a href="https://api.whatsapp.com/send?phone=917838704822&text=Hello%20Pankaj" target="_blank" rel="noreferrer" className="btn-get-started scrollto d-inline-flex align-items-center justify-content-center align-self-center">
                <span>WhatsApp</span>
                <i className="bi bi-arrow-right"></i>
              </a>
            </div>
          </div>
        </div>
        <div className="col-lg-6 hero-img" data-aos="zoom-out" data-aos-delay="200">
              <div className="img-area">
      <div className="inner-area">
        <img src="../assets/img/123.png" alt="best web designer in gurgaon" />
      </div>
    </div>
        </div>
      </div>
    </div> 
</div>
  </section>   



    <main id="main">
 <section id="pageContent" className="pageContent">

      <div className="container" data-aos="fade-up">
        <header className="section-header">
          <h2>Search Engine Optimization (SEO)</h2>
        </header>

        <div className="row">
          <div className="col-lg-12">
<div class="hero-section text-center">
  <p>Rank Higher on Google and Drive More Traffic with Expert SEO Services in Gurgaon</p>
  <a href="/contact" class="btn btn-primary mt-3">Request Free SEO Audit</a>
</div>

<div class="intro-section py-5">
  <h2>Why SEO Matters</h2>
  <p>Search Engine Optimization (SEO) is the process of improving your website’s visibility on search engines like Google. Whether you're a local business or an online brand, SEO ensures your website shows up when potential customers are searching.</p>
  <p>As a freelance SEO expert in Gurgaon, I offer full-service SEO that includes technical audits, content optimization, and authority building — all tailored to help you rank higher, get more clicks, and increase conversions.</p>
</div>

<div class="services-section py-5">
  <h2>What’s Included in My SEO Services</h2>
  <ul>
    <li>✅ In-depth SEO Audit & Keyword Research</li>
    <li>✅ On-Page Optimization (Meta Tags, Structure, Content)</li>
    <li>✅ Technical SEO (Speed, Crawlability, Mobile UX)</li>
    <li>✅ Off-Page SEO (Backlinks, Citations, Social Signals)</li>
    <li>✅ Google My Business Optimization</li>
    <li>✅ Local SEO for City & Area-Based Searches</li>
    <li>✅ Competitor Analysis & Gap Opportunities</li>
    <li>✅ Monthly Reporting & Continuous Improvement</li>
  </ul>
</div>

<div class="why-choose-me py-5">
  <h2>Why Choose Me for SEO?</h2>
  <p>✔ 11+ Years of Digital Marketing & Web Experience</p>
  <p>✔ Proven Results in Ranking Local and National Websites</p>
  <p>✔ 100% White-Hat Techniques (Google-Safe)</p>
  <p>✔ Transparent Reporting & Ethical Practices</p>
  <p>✔ Freelance Pricing – No Agency Overhead</p>
</div>

<div class="faq-section py-5">
  <h2>Frequently Asked Questions</h2>

  <div class="faq-item">
    <h3>What is SEO and how does it help my business?</h3>
    <p>SEO improves your website’s ranking on Google so that more people can find you when searching for your services. It boosts traffic, leads, and trust.</p>
  </div>

  <div class="faq-item">
    <h3>How long before I see results?</h3>
    <p>SEO results typically start appearing within 2–3 months. However, rankings and traffic improve steadily over time with consistent efforts.</p>
  </div>

  <div class="faq-item">
    <h3>What tools do you use for SEO?</h3>
    <p>I use Google Search Console, Ahrefs, SEMrush, Screaming Frog, GTmetrix, and other tools for audit, research, and performance tracking.</p>
  </div>

  <div class="faq-item">
    <h3>Do you provide monthly reports?</h3>
    <p>Yes. You’ll receive a detailed report every month with keyword rankings, traffic trends, backlinks, and next action items.</p>
  </div>

  <div class="faq-item">
    <h3>Can you help with local SEO?</h3>
    <p>Absolutely. I optimize Google My Business, local citations, and target keywords for location-based searches to improve map rankings.</p>
  </div>

  <div class="faq-item">
    <h3>Is SEO better than running ads?</h3>
    <p>SEO provides long-term traffic with no per-click cost. Ads give immediate results, but SEO builds lasting online authority over time.</p>
  </div>

  <div class="faq-item">
    <h3>Do you offer link building services?</h3>
    <p>Yes. I offer white-hat link building through guest posts, business directories, and high-authority backlinks that boost your domain authority.</p>
  </div>
</div>

<div class="cta-section py-5 text-center">
  <h2>Let’s Grow Your Organic Traffic</h2>
  <p>Partner with me for ethical, effective SEO strategies that deliver real growth — not just rankings.</p>
  <a href="/contact" class="btn btn-success mt-3">Book Your Free SEO Consultation</a>
</div>

          </div>

        </div>
      </div>

    </section>
    <Contact /> 
    </main>
    </>
  );
}
export default App1;
